import React from 'react';

const getGlowColor = (score) => {
  if (score >= 8) return 'bg-[#e5e1f9]/80 text-[#5b21b6] border-[#ddd6fe]'; // Soft purple
  if (score >= 6) return 'bg-[#d1ece5]/80 text-[#0f766e] border-[#bbf7d0]'; // Soft mint
  return 'bg-[#ffe0d2]/80 text-[#c2410c] border-[#fed7aa]'; // Soft peach
};

export default function GlowScoreBadge({ score, size = 'sm' }) {
  const colors = getGlowColor(score);
  const sizeClasses = size === 'lg' ? 'px-4 py-2 text-base' : 'px-2.5 py-1 text-xs';
  
  return (
    <div className={`${colors} border ${sizeClasses} rounded-full font-semibold font-sans flex items-center gap-1 backdrop-blur-sm`}>
      <span>✦</span>
      <span>{score}/10</span>
    </div>
  );
}